import { globalLayout } from '@atlassian/jira-global-layout';

import { createEntry } from '@atlassian/jira-router';
import { legacyGinBulkRoute } from '@atlassian/jira-router-routes-legacy-gin-bulk-routes';

export const legacyGinBulkRouteEntry = createEntry(legacyGinBulkRoute, {
	layout: globalLayout,
});
